import React from 'react';
import MobileCard from '../mobileCard/MobileCard';

const SkeletonDashboard = () => {
  return (
    <div className="space-y-3 mt-8 w-full">
      {/* Greeting Skeleton */}
      <MobileCard className="bg-gray-50 border-gray-200" padding="p-3 md:p-2">
        <div className="text-center space-y-2">
          <div className="h-6 bg-gray-300 rounded w-3/4 mx-auto"></div>
          <div className="h-5 bg-gray-200 rounded w-1/2 mx-auto"></div>
        </div>
      </MobileCard>

      {/* Antes y Ahora / Timelapse tabs Skeleton */}
      <MobileCard className="border-0 shadow-xl overflow-hidden" padding="p-2 md:p-3">
        <div className="mb-2 flex items-center gap-2">
          <div className="h-7 bg-gray-300 rounded-lg w-28"></div>
          <div className="h-7 bg-gray-200 rounded-lg w-36"></div>
        </div>
        <div className="w-full aspect-video bg-gray-300 rounded-lg relative">
            <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-gray-400"></div>
            </div>
        </div>
      </MobileCard>

      {/* WhatsApp CTA button Skeleton */}
      <div className="grid grid-cols-1 gap-2">
        <div className="h-12 bg-gray-300 rounded-lg"></div>
      </div>

      {/* Explorar Archivo button Skeleton */}
      <div className="grid grid-cols-1 gap-2">
        <div className="h-12 bg-gray-300 rounded-lg"></div>
      </div>
    </div>
  );
};

export default SkeletonDashboard;
